var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWRook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 45,
    height: 45,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 1,
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "#000000",
      strokeWidth: 1.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(0,0.3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 9,39 L 36,39 L 36,36 L 9,36 L 9,39 z ",
    style: {
      strokeLinecap: "butt"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 12,36 L 12,32 L 33,32 L 33,36 L 12,36 z ",
    style: {
      strokeLinecap: "butt"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 11,14 L 11,9 L 15,9 L 15,11 L 20,11 L 20,9 L 25,9 L 25,11 L 30,11 L 30,9 L 34,9 L 34,14",
    style: {
      strokeLinecap: "butt"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 34,14 L 31,17 L 14,17 L 11,14"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M 31,17 L 31,29.5 L 14,29.5 L 14,17",
    style: {
      strokeLinecap: "butt",
      strokeLinejoin: "miter"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M 31,29.5 L 32.5,32 L 12.5,32 L 14,29.5"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M 11,14 L 34,14",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeLinejoin: "miter"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWRook);
export default __webpack_public_path__ + "static/media/w_rook.9e48b84f189eea24339f8a679e7a664f.svg";
export { ForwardRef as ReactComponent };